export default function (store, to) {
  // console.log('hello')
  // console.log(context)
  store.commit('updatePage', to)
}